module.exports = __webpack_public_path__ + "img/warning.80a685d7.svg";